<template>
    <div class="mentoring-activity-list">
        <component
            v-for="(item, i) in items"
            :key="item.id"
            :item="item"
            @click="$emit('click', { index: i, event_type: $event })"
            :is="getCardComponent(item)"
            :class="[getCardComponent(item)]"
        ></component>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import {ActivityStatus, ActivityType} from '../../../../../stores/mentoring/activities';

import DefaultCard from './DefaultCard';
import MeetingCard from './MeetingCard';

export default {
    name: 'ActivityList',
    data: () => ({
        labels: {
            webinar: 'Вебинар',
            session: 'Сессия',
            course: 'Курс',
            meeting: 'Встреча',
        },
    }),
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    components: {
        DefaultCard,
        MeetingCard,
    },
    methods: {
        getCardComponent(item) {
            return this.role === 'mentor'
                && item.type === ActivityType.meeting
                && item.status === ActivityStatus.confirmation
                ? 'MeetingCard'
                : 'DefaultCard';
        },
    },
    computed: {
        ...mapState('mentoring', [
            'role',
        ]),
    },
};
</script>

<style lang="scss">
    @import '../../../../../styles/rem';

    .mentoring-activity-list {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: rem(24);

        @include on-mobile {
            display: block;
        }

        .item {
            width: 100%;
            margin-right: rem(24);
            /*height: rem(374);*/
            background: #F6F7FB;
            border-radius: rem(4);
            display: flex;
            justify-content: space-between;
            flex-direction: column;

            &.MeetingCard {
                grid-column: 1 / span 3;
            }

            @include on-mobile {
                margin-right: 0;
                margin-bottom: mrem(24);
                border-radius: mrem(4);
            }

            $icons:
                "webinar" #51BA20 rgba(81, 186, 32, 0.3),
                "session" #783AFC rgba(120, 58, 252, 0.3),
                "course" #FC923A rgba(252, 146, 58, 0.3),
                "meeting" #3AA0FD rgba(58, 160, 253, 0.3);

            @each $type, $color, $color2 in $icons {
                &--#{$type} {
                    .label,
                    .time,
                    .date,
                    .action_btn,
                    .show-details {
                        color: $color;
                    }
                    .action_btn {
                        border-color: $color;
                    }
                    .label,
                    .show-details {
                        background-color: $color2;
                    }
                }
            }

        }

        .top,
        .bottom {
            width: 100%;
        }

        .main {
            min-height: rem(230);
            padding: rem(16);
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            @include on-mobile {
                min-height: mrem(230);
                padding: mrem(16);
            }
        }

        .bottom {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .show-details {
            height: rem(40);
            width: 100%;
            background-color: #00ACEE;
            border-radius: 0 0 rem(4) rem(4);
            line-height: rem(40);
            text-align: center;
            font-weight: bold;
            font-size: rem(16);
            user-select: none;
            cursor: pointer;
            margin-top: rem(16);

            @include on-mobile {
                height: mrem(40);
                border-radius: 0 0 mrem(4) mrem(4);
                line-height: mrem(40);
                font-size: mrem(16);
                margin-top: mrem(16);
            }
        }

        .row {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            margin-bottom: rem(8);

            @include on-mobile {
                margin-bottom: mrem(8);
            }
        }

        .label {
            font-weight: 600;
            font-size: rem(14);
            line-height: rem(20);
            padding: rem(6) rem(12);
            display: inline-block;
            border-radius: rem(32);

            @include on-mobile {
                font-size: mrem(14);
                line-height: mrem(20);
                padding: mrem(6) mrem(12);
                border-radius: mrem(32);
            }
        }

        .avatar {
            height: rem(32);
            width: rem(32);
            border-radius: rem(32);
            background-image: url("../../../../../assets/images/avatar_placeholder.png");
            background-size: contain;
            background-repeat: no-repeat;

            @include on-mobile {
                height: mrem(32);
                width: mrem(32);
                border-radius: mrem(32);
            }
        }

        .time {
            margin-right: rem(8);

            @include on-mobile {
                margin-right: mrem(8);
            }
        }

        .date {
            width: 100%;
            font-weight: 600;
            font-size: rem(14);
            line-height: rem(20);
            margin-bottom: rem(8);

            @include on-mobile {
                font-size: mrem(14);
                line-height: mrem(20);
                margin-bottom: mrem(8);

            }
        }

        .theme {
            font-weight: 600;
            font-size: rem(16);
            line-height: rem(24);
            color: #000000;
            margin-bottom: rem(8);

            @include on-mobile {
                font-size: mrem(16);
                line-height: mrem(24);
                margin-bottom: mrem(8);
            }
        }

        .location,
        .confirmation {
            font-size: rem(14);
            line-height: rem(20);
            color: #000000;

            @include on-mobile {
                font-size: mrem(14);
                line-height: mrem(20);
            }

            .tag {
                font-size: rem(14);
                line-height: rem(20);
                color: #8F9398;
                margin-bottom: rem(4);

                @include on-mobile {
                    font-size: mrem(14);
                    line-height: mrem(20);
                    margin-bottom: mrem(4);
                }
            }
        }

        .action_btn {
            display: block;
            border-width: 1px;
            border-style: solid;
            padding: rem(6) rem(13);
            font-weight: 600;
            font-size: rem(12);
            height: rem(32);
            border-radius: rem(32);
            width: rem(182);
            line-height: rem(18);
            cursor: pointer;
            user-select: none;
            text-align: center;
            margin-top: rem(8);

            @include on-mobile {
                width: 100%;
                padding: mrem(6) mrem(13);
                font-size: mrem(12);
                height: mrem(32);
                border-radius: mrem(32);
                line-height: mrem(18);
                margin-top: mrem(8);
            }
        }

        .align-center {
            align-items: center;
        }
    }
</style>